import React, { useState, useEffect } from 'react'
import { Link, useLocation, useHistory } from "react-router-dom";
import { AppBar, Container, Typography, Button, Toolbar, IconButton } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import decode from "jwt-decode";
import { logout } from "./../redux/actions/user";
import Menu from "./Menu";
import SearchMenu from "./SearchMenu";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    title: {
        flexGrow: 1,
    }
}));

const NavBar = () => {
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const [user, setUser] = useState(JSON.parse(localStorage.getItem("profile")));

    useEffect(() => {
        setUser(JSON.parse(localStorage.getItem("profile")));

        const token = user?.token;

        if (token) {
            const decodedToken = decode(token);

            if (decodedToken.exp * 1000 < new Date().getTime()) {
                logout(history);
            }
        }
    }, [location]);

    return (
        <div className={classes.root} style={{ marginBottom: "15px" }}>
            <Container maxWidth="lg">
                <AppBar position="static">
                    <Toolbar>
                        <SupervisedUserCircleIcon fontSize="large" />&nbsp;
                        <Typography component={Link} to="/" variant="h4" className={classes.title} style={{ fontWeight: "bolder" }}>
                            K-Network
                        </Typography>

                        <SearchMenu />

                        {user ?
                            (
                                <Menu />
                            ) :
                            (
                                location.pathname !== "/auth" &&
                                <Button component={Link} to="/auth" color="inherit" size="large">Login</Button>
                            )
                        }
                    </Toolbar>
                </AppBar>
            </Container>
        </div>
    )
}

export default NavBar